// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"0":"81f09a27","202":"5ff1ca68","238":"af8d1f18","274":"8ca5e8a0","318":"415a7123"}[chunkId] + ".chunk.js";
};